import { HStack, IconButton, Button } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

export interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationProps) => {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <HStack mt={10} spacing={{ base: 1, md: 2 }} justify="center" flexWrap="wrap">
      {/* Previous button */}
      <IconButton
        aria-label="Previous page"
        icon={<ChevronLeftIcon />}
        isDisabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        variant="ghost"
        size="md"
        colorScheme="teal"
        _hover={{ bg: "rgba(0, 113, 136, 0.1)", transform: "scale(1.05)" }}
        transition="all 0.2s ease"
      />

      {/* Page buttons */}
      {pages.map((page) => (
        <Button
          key={page}
          onClick={() => onPageChange(page)}
          variant={page === currentPage ? "solid" : "ghost"}
          colorScheme="teal"
          size={{ base: "sm", md: "md" }}
          borderRadius="full"
          minW={{ base: 8, md: 10 }}
          px={{ base: 2, md: 4 }}
          bg={page === currentPage ? "#007188" : "transparent"}
          color={page === currentPage ? "white" : "#007188"}
          boxShadow={page === currentPage ? "0 4px 12px rgba(0,113,136,0.3)" : "none"}
          _hover={{
            bg: page === currentPage ? "#006274" : "rgba(0, 113, 136, 0.1)",
            transform: "scale(1.05)",
          }}
          transition="all 0.2s ease"
        >
          {page}
        </Button>
      ))}

      {/* Next button */}
      <IconButton
        aria-label="Next page"
        icon={<ChevronRightIcon />}
        isDisabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        variant="ghost"
        size="md"
        colorScheme="teal"
        _hover={{ bg: "rgba(0, 113, 136, 0.1)", transform: "scale(1.05)" }}
        transition="all 0.2s ease"
      />
    </HStack>
  );
};

export default Pagination;
